export const columnTypes = {
    actions: {},
    bar: {},
    binary: {},
    boolean: {},
    count: {},
    date: {},
    icon: {},
    iconAttachment: {},
    layer: {},
    list: {},
    mock: {},
    multiIcon: {},
    number: {},
    roles: {},
    statusIcon: {},
    string: {},
    text: {},
    tooltipList: {},
};
